import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";

function EditCategory() {
  document.title = "Edit Category";
  let navigate = useNavigate();
  const { id } = useParams();

  const [category, setCategory] = useState({ name: "" });
  const [message, setMessage] = useState("");

  // Fetching category data by id from database
  useQuery("categoryCache", async () => {
    const response = await API.get("/category/" + id);
    setCategory({ name: response.data.data.name });
  });

  const handleChange = (e) => {
    setCategory({
      ...category,
      name: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const body = JSON.stringify(category);

      await API.patch("/category/" + id, body, config);

      navigate("/category");
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <NavigasiAdmin active="category" />
      <div className="edit-category-section container">
        <p className="mt-5 fw-bold">Edit Category</p>
        <form onSubmit={(e) => handleSubmit.mutate(e)}>
          {message && message}

          <input
            type="text"
            onChange={handleChange}
            value={category.name}
            placeholder="category"
            className="form-control bg-dark mb-4 text-white"
          />
          <button className="btn btn-success fw-bold w-100">Save</button>
        </form>
      </div>
    </>
  );
}

export default EditCategory;
